// Angular imports
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Service imports
import { MPCacheRegistrationService } from '../../_services/shared-services/mp-cache-registration-service';
// Constants imports
import { CacheDuration } from '../../_constants/cache-duration';
import { URLConstants } from '../../_constants/url-constants';
// Model imports
import { BaseProcessNotesResultDto } from '../../management-common/_models/notes/base-process-notes-result-dto';
import { AccDocumentDetailsResultDto } from '../../shared-acc-board-approval-module/_models/acc-documents-details-result-dto';
import { AccEditorResultDto } from '../../shared-acc-board-approval-module/_models/acc-editor-result-dto';
import { AccDetailResultDto } from '../_models/acc-detail-result-dto';
import { AccHistoryResultDto } from '../_models/acc-history-result-dto';
import { AccOpenStatusResultDto } from '../_models/acc-open-status-result-dto';
import { AddACCResultDto } from '../_models/add-acc-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../_services/shared-services/mp-cache-registration-service";
export class SharedAccApplicationService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getAccOpenApplication(baseParams) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/open${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(AccOpenStatusResultDto, response)));
    }
    getAccOpenEditor(baseParams) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/open/editor${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(AccEditorResultDto, response)));
    }
    getAccProjectHistoryLog(baseParams) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/project/history${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(AccHistoryResultDto, response)));
    }
    getAccItemHistoryLog(baseParams) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/item/history${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(AccHistoryResultDto, response)));
    }
    getAccProjectNotes(baseParams) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/project/notes${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(BaseProcessNotesResultDto, response)));
    }
    getAccItemNotes(baseParams) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/item/notes${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(BaseProcessNotesResultDto, response)));
    }
    saveAccProjectNotes(param) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/project/notes`;
        return this.httpClient.post(url, classToPlain(param));
    }
    saveAccItemNotes(param) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/item/notes`;
        return this.httpClient.post(url, classToPlain(param));
    }
    getAccDetails(baseParams) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/details${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(AccDetailResultDto, response)));
    }
    addAcc(param) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}`;
        return this.httpClient
            .post(url, classToPlain(param))
            .pipe(map((response) => plainToClass(AddACCResultDto, response)));
    }
    updateAcc(param) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}`;
        return this.httpClient.put(url, classToPlain(param));
    }
    getAccApplicationDocumentDetail(baseParams) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/document/details${baseParams.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(AccDocumentDetailsResultDto, response)));
    }
    uploadProjectDocuments(params) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/project/documents`;
        return this.httpClient.post(url, classToPlain(params));
    }
    uploadItemDocument(params) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/item/document`;
        return this.httpClient.post(url, classToPlain(params));
    }
    uploadItemDocuments(params) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/item/documents`;
        return this.httpClient.post(url, classToPlain(params));
    }
    unlinkProjectDocument(params) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/project/document/unlink`;
        return this.httpClient.put(url, classToPlain(params));
    }
    unlinkItemDocument(params) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/item/document/unlink`;
        return this.httpClient.put(url, classToPlain(params));
    }
    downloadProjectDocument(params) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/project/document/download${params.getQueryString()}`;
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((response) => new Blob([response])));
    }
    downloadItemDocument(params) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/item/document/download${params.getQueryString()}`;
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((response) => new Blob([response])));
    }
    accFinalizeUnfinalizeItem(params) {
        const url = `${URLConstants.ccAccApplicationBaseApiUrl}/action/finalize-unfinalize`;
        return this.httpClient.put(url, classToPlain(params));
    }
}
SharedAccApplicationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SharedAccApplicationService_Factory() { return new SharedAccApplicationService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: SharedAccApplicationService, providedIn: "root" });
